import dayjs from '../../../utils/dayjsConfig'

// Convierte los segundos transcurridos en horas totales y minutos restantes.
export function elapsedLabel(seconds) {
  const elapsedSeconds = Math.max(0, seconds || 0)
  const hours = Math.floor(elapsedSeconds / 3600)
  const minutes = Math.floor((elapsedSeconds % 3600) / 60)
  return `${hours} h ${minutes} min`
}
// Muestra la fecha en la hora local de la máquina y el formato solicitado.
export const operationalTime = (value, format) => (value ? dayjs(value).format(format) : '—')
